module.exports = __webpack_public_path__ + "static/media/chrome.241af90d.png";